import { HttpInterceptorFn, HttpRequest, HttpHandlerFn } from '@angular/common/http';
import { environment } from '@environments/environment';

const urlPrefixes: string[] = ['assets', 'http', 'https'];

const checkPrefix = (url: string): boolean => urlPrefixes.every(prefix => !url.includes(prefix));

const ignoreApi = (url: string): boolean => !url.includes('http://ipinfo.io');

export const UrlInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  if (checkPrefix(request.url) && ignoreApi(request.url)) {
    request = request.clone({
      url: `${environment.api_url}${request.url}`,
    });
  }

  return next(request);
};
